<template>
    <div v-loading="loading" class="table-list" >
      <el-table
        :data="tableData"
        @expand-change="handleExpand"
        style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="img-list">
                  <img v-for="(itm,i) in props.row.apiImgList" :key="itm['url']"
                       :src="itm['url']"
                       :data-id="itm['url']" @click="clickImg(itm)" :class="itm['isCheck']?'selected-img':''"/>
            </div>
            <el-button type="info" round style="margin: 10px;" @click="$refs['imgPreviewRef'].init(1)">预览</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="店铺名称"
          prop="storeName">
        </el-table-column>
        <el-table-column
          label="店铺类型"
          prop="storeType">
        </el-table-column>

      </el-table>


      <Pagination
        :currentPage="query.pageNo"
        :total="total"
        :pageSize="query.pageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></Pagination>

      <img-preview :src-list="storeImgList" ref="imgPreviewRef"></img-preview>

    </div>



</template>


<script>
import {getAction} from '@/api/manage.js'
import imgPreview from "./img-preview";
import Pagination from "../components/pagination";
import qs from 'qs'


export default {
  components:{
    imgPreview,
    Pagination
  },
  data() {
    return {
      loading: false,
      tableData: [],
      storeImgList:[],
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 20,
        keyWords: '',
        orderStatusValue: ''
      },
    }
  },
  created() {
    this.loadData();
  },
  methods:{
    loadData() {
      this.dataList = []
      this.loading = true
      getAction(`/google-map/v0.2/get-api-photos`, this.query).then(response => {
        if (response.success && response.result !== null) {
          this.total = response.result.total
          this.query.pageNo = response.result.current
          this.query.pageSize = response.result.size
          const records = response.result.records || []
          this.tableData = records
          this.loading = false
        } else {
          this.loading = false
          this.$message.warning(response.message)
        }
      })

    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNo = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.query.pageNo = currentPage
      this.loadData()
    },
    clickImg(itm){
      getAction(`/google-map/v0.2/selected-api-photo?${qs.stringify(itm)}`).then(response => {
        if (response.success) {
          itm['isCheck'] = true
          //this.$set(this.orderDetails[idx], 'total', (value * row['priceBefore']).toFixed(2))
          this.$message.success(response.message)
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handleExpand(row, expanded) {
      // row 是当前点击的行的数据
      // expandedRows 是当前已展开的所有行的数据
      this.storeImgList = row['apiImgList'].map(f=>f['url'])

    }


  },



}
</script>

<style scoped  lang="less">
.img-list{
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  img{
    margin: 10px;
    width: 180px;
    object-fit: cover;
    height: 180px;
    cursor: pointer;
  }
  .selected-img{
    border: #FB541C 5px solid;
  }

}
.table-list /deep/ .has-gutter th .cell{
  font-family: Satoshi-Bold !important;
  color: #000000 !important;
  font-weight: unset !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/vilocal/api-img-review.vue